import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { Filtration, FilterPagingCriteria } from "../../dataModels/";

@Component({
    moduleId: module.id,
    selector: 'infinite-list',
    template: `
    <div [class]="className" infiniteScroll [infiniteScrollDistance]="1" [scrollWindow]="false" [infiniteScrollThrottle]="50"
        (scrolled)="onScrollDown()">
        <ng-content></ng-content>
    </div>
    `,
    styles: [
        `
        dsiv {
            overflow-y : scroll;
        }
        `
    ]
})
export class InfiniteListComponent {

    @Input() className: string;
    @Input() pageSize: number;
    @Input() paging: FilterPagingCriteria;
    @Input() set filter(value: Filtration) {
        this.paging = value.PageCriteria;
    }
    
    @Output("scroll") onScroll: EventEmitter<FilterPagingCriteria> = new EventEmitter<FilterPagingCriteria>();

    constructor() {
    }

    ngOnInit() {
        if (!(this.paging instanceof FilterPagingCriteria)) {
            this.paging = new FilterPagingCriteria();
        }

        this.pageSize = this.pageSize || 10;
        this.paging.PageSize = this.pageSize;

        this.className = this.className || "";
        this.className += " inf-scroll-results";

        this.onScroll.emit(this.paging);
    }

    onScrollDown() {
        this.paging.PageNumber++;

        this.onScroll.emit(this.paging);
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/infiniteList/infinite-list.component.ts